import { useSubmitDisputeMutation } from "@features/vessel-call/vessel-call-status/Operations/hooks/useSubmitDisputeMutation";

export const useSubmitDispute = () => {
  const { submit, isSubmitting } = useSubmitDisputeMutation({
    successTitleKey: "dispute-success-title",
    invalidateDetails: true,
  });

  return {
    submitDispute: submit,
    isSubmittingDispute: isSubmitting,
  };
};
